/* eslint-disable no-console */
import { MouseEvent, useRef } from "react";
// import useLongPress from "src/hooks/ui/useLongPress";
import { LongPressDetectEvents, useLongPress } from "use-long-press";

type Params = {
  editMode: boolean;
  rowSelectMode: boolean;
  allowRowSelection: boolean;
  onRowSelect: () => void;
  onRowClick: () => void;
};
// WARNING -- Safari browser triggers also onClick after onPress. For that case
// there is useRef variable rowPressed which works as traffic light.
const useMobileTableRowEventListeners = ({
  editMode,
  allowRowSelection,
  rowSelectMode,
  onRowClick,
  onRowSelect,
}: Params) => {
  // for aborting onClick row after row beeing pressed
  const rowPressed = useRef(false);

  const shouldAbortAction = (e: MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;

    const hasAbortAttr = !!target.closest("[data-abort-row-click]");
    const isInsideAnchor = !!target.closest("a");
    const isInsideButton = !!target.closest("button");
    const isInsideFileList = !!target.closest("#file-list-menu");

    return hasAbortAttr || isInsideAnchor || isInsideButton || isInsideFileList;
  };

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    if (editMode || shouldAbortAction(e)) return;

    if (rowPressed.current) {
      rowPressed.current = false;
      return;
    }

    if (rowSelectMode && allowRowSelection) {
      onRowSelect();
      return;
    }

    onRowClick();
  };

  const handleOnPressStart = () => {
    if (rowSelectMode) return;
    setTimeout(() => {
      rowPressed.current = true;
    }, 500);
    setTimeout(() => {
      rowPressed.current = false;
      // 1500 bcs 1000 for press threshold on line 66 and 500 for timeout treshold to no trigger onClick
    }, 1500);
  };

  const handleLongpress = () => {
    if (editMode || rowSelectMode) return;
    if (allowRowSelection) onRowSelect();
  };

  const longPressListeners = useLongPress(handleLongpress, {
    threshold: 1000,
    cancelOnMovement: false,
    detect: LongPressDetectEvents.BOTH,
    onStart: handleOnPressStart,
  });

  return {
    ...longPressListeners(),
    onClick: handleClick,
  } as const;
};

export default useMobileTableRowEventListeners;
